import { DateTime } from 'luxon';

export function bookingStatusDate(date: Date | string, timezone: string): DateTime {
  const value = (typeof date === 'string' ? DateTime.fromISO(date) : DateTime.fromJSDate(date)).setZone(timezone).setLocale('en-US');
  if (!value.isValid) throw new RangeError('Invalid booking date or timezone');
  return value;
}

/** The complete first line fits Telegram's narrow pinned-message bar. */
export function statusLine(verb: 'Booked' | 'Moved', date: Date | string, timezone: string): string {
  return `${verb} · ${bookingStatusDate(date, timezone).toFormat('LLL d, h:mm a')}`;
}
